import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RBTeamMember, GSL, GslTeamTypes } from '../Models/Team';
import { HttpClient } from '@angular/common/http';
import { SharedService } from 'src/app/core/Services/shared.service';
import { catchError, map } from 'rxjs/operators';

@Injectable()

export class TeamService {
    constructor(private _http: HttpClient, private _shared: SharedService) {}

    // Get all members
    getAllMembers(): Observable<RBTeamMember[]> {
        return this._http.get<RBTeamMember[]>(`${this._shared.apiPath}teammembers`).pipe(catchError(this._shared.handleError));
    }

    // Get member by teammemberID
    getMemberByID(teammemberID: number): Promise<RBTeamMember> {
        return this._http.get<RBTeamMember>(`${this._shared.apiPath}teammembers/${teammemberID}`)
        .pipe(map(r => {return <RBTeamMember>r['result']}),catchError(this._shared.handleError)).toPromise();
    }

    // Add new member
    addTeamMember(member: RBTeamMember): Observable<any> {
        return this._http.post<any>(`${this._shared.apiPath}teammembers`, member).pipe(catchError(this._shared.handleError));
    }

    // Update teammember
    updateTeamMember(member: RBTeamMember): Observable<any> {
        return this._http.put<any>(`${this._shared.apiPath}teammembers/${member.teammemberID}`, member)
                .pipe(catchError(this._shared.handleError));
    }

    // Delete member by teammemberID
    deleteMemberByID(teammemberID: number): Observable<any> {
        return this._http.delete<any>(`${this._shared.apiPath}teammembers/${teammemberID}`).pipe(catchError(this._shared.handleError));
    }

    // Update member profilePic by teammemberID
    updateTeamMemberProfilePic(teammemberID: number, picture: FormData) {
        return this._http.put<any>(`${this._shared.apiPath}saveImage/${teammemberID}`, picture).pipe(catchError(this._shared.handleError));
    }


    // GSL=========================================================================================
    
    // Get GSL list
    getGSL(): Observable<GSL[]> {
        return this._http.get<GSL[]>(`${this._shared.apiPath}gsl`).pipe(catchError(this._shared.handleError));
    }
    
    // Add GSL
    addGSL(gsl: GSL): Observable<any> {
        return this._http.post<any>(`${this._shared.apiPath}gsl`, gsl).pipe(catchError(this._shared.handleError));
    }

    // Edit GSL
    editGSL(gsl: GSL): Observable<any> {
        return this._http.put<any>(`${this._shared.apiPath}gsl/${gsl.gslID}`, gsl).pipe(catchError(this._shared.handleError));
    }

    // Update GSL Order
    updateGSLOrder(order): Promise<any> {
        return this._http.put<any>(`${this._shared.apiPath}gsl`, order).pipe(catchError(this._shared.handleError)).toPromise();
    }

    // Delete GSL
    deleteGSL(gslID: number): Observable<any> {
        return this._http.delete<any>(`${this._shared.apiPath}gsl/${gslID}`).pipe(catchError(this._shared.handleError));
    }

    // Get teamTypes of GSL
    getTeamTypesByGslID(gslID: number): Promise<GslTeamTypes[]> {
        return this._http.get<GslTeamTypes[]>(`${this._shared.apiPath}gsl/${gslID}`)
            .pipe(map(r => { return <GslTeamTypes[]>r['result']; }), catchError(this._shared.handleError)).toPromise();
    }

    // Add new teamType in GSL
    addTeamTypeInGSL(data): Promise<any> {
        return this._http.post<any>(`${this._shared.apiPath}teams`, data).pipe(catchError(this._shared.handleError)).toPromise();
    }

    // Delete teamType from GSL
    deleteTeamType(teamTypeID: number): Observable<any> {
        return this._http.delete<any>(`${this._shared.apiPath}teams/${teamTypeID}`).pipe(catchError(this._shared.handleError));
    }

    // Update GSL team order
    updateGslTeamOrder(order): Promise<any> {
        let result = { result: order };
        return this._http.put<any>(`${this._shared.apiPath}teams`, result).pipe(catchError(this._shared.handleError)).toPromise();
    }

    // Get teammembers associated with all teamTypes for a gslID
    getTeamMembersOfGsl(gslID: number): Promise<RBTeamMember[]> {
        return this._http.get<RBTeamMember[]>(`${this._shared.apiPath}gsl/teammembers/${gslID}`)
            .pipe(map(r => { return <RBTeamMember[]>r['result']; }, catchError(this._shared.handleError))).toPromise();
    }
    
    // Get teammembers of teamType
    getTeamMembersByTeamTypeID(teamTypeID: number): Promise<RBTeamMember[]> {
        return this._http.get<RBTeamMember[]>(`${this._shared.apiPath}teams/${teamTypeID}`)
            .pipe(map(r => { return <RBTeamMember[]>r['result']; }), catchError(this._shared.handleError)).toPromise();
    }

    // Add teammember to GslTeamType
    linkTeamMemberOnGslTeamType(data): Promise<any> {
        return this._http.post<any>(`${this._shared.apiPath}gsl/teammembers`, data).pipe(catchError(this._shared.handleError)).toPromise();
    }

    // Delete teammember from GslTeamType
    unlinkTeamMemberFromGslTeamType(teamTypeID: number, teammemberID: number): Promise<any> {
        return this._http.delete<any>(`${this._shared.apiPath}gsl/teammembers/${teamTypeID}/${teammemberID}`).pipe(catchError(this._shared.handleError))
                .toPromise();
    }

    // Update gsl teammembers order
    updateGslTeamMembersOrder(order: any) {
        return this._http.put<any>(`${this._shared.apiPath}gsl/teammembers`, order).pipe(catchError(this._shared.handleError));
    }
}